import React from "react";
import SvgLogo from "../components/SvgLogo";
import { PORTFOLIO } from "../config/portfolio";
import { LOGO_MAP } from "../config/logos";

const LOGO_OPTICAL_SCALE = {
  rise: 0.84,
};

function parseStage(s) {
  if (!s) return { stage: "", round: "" };
  const parts = s.trim().split(" ");
  const last = parts[parts.length - 1];
  const isYear = /^\d{4}$/.test(last);
  return {
    stage: isYear ? parts.slice(0, -1).join(" ") : s,
    round: isYear ? last : "",
  };
}

export default function PortfolioPage() {
  return (
    <section className="section" style={{ minHeight: "100vh" }}>
      <div className="container">
        <div className="section-header">
          <span className="eyebrow">Fund I · 2025 vintage</span>
          <h1 style={{ margin: 0 }}>Portfolio Companies</h1>
        </div>
        <hr className="hairline" style={{ marginBottom: "var(--space-48)" }} />

        <div className="portfolio-grid">
          {PORTFOLIO.map((p, i) => {
            const { stage, round } = parseStage(p.stage);
            return (
              <article
                key={i}
                className="portfolio-card"
              >
                <div className="portfolio-card__body">
                  <div className="portfolio-card__logo">
                    <SvgLogo
                      url={LOGO_MAP[p.id]}
                      label={p.name}
                      width="180px"
                      height="44px"
                      fit="frame"
                      className="portfolio-card__logo-mark"
                      style={{
                        "--portfolio-logo-scale": LOGO_OPTICAL_SCALE[p.id] || 1,
                      }}
                    />
                  </div>
                  <p className="portfolio-card__desc">{p.desc}</p>
                </div>
                <div className="portfolio-card__meta">
                  {(stage || round) && (
                    <span className="portfolio-card__stage-pill">
                      {[stage, round].filter(Boolean).join(" | ")}
                    </span>
                  )}
                  <div className="portfolio-card__actions">
                    <a
                      href={p.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="portfolio-card__link portfolio-card__link--icon"
                      aria-label={`Open ${p.name} website`}
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <path d="M2 12h20" />
                        <path d="M12 2a15.3 15.3 0 0 1 0 20" />
                        <path d="M12 2a15.3 15.3 0 0 0 0 20" />
                      </svg>
                    </a>
                    {p.tw && (
                      <a
                        href={`https://x.com/${p.tw}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="portfolio-card__link portfolio-card__link--icon"
                        aria-label={`Open ${p.name} X profile`}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                        </svg>
                      </a>
                    )}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
